import  { FC, useEffect } from 'react'; 
import styles from './TopMenuForProduct.module.scss';
import { ReactComponent as GoBackIcon } from 'images/new-icons/arrow-go-back.svg';
import { ReactComponent as Bag } from 'images/dark-green-cart.svg';
import useGetProductReviewsByProductId from 'sdk/hooks/shop/useGetProductReviewsByProductId';
import { useParams } from 'react-router-dom';
import { ReactComponent as Star } from 'images/new-icons/yellow-star.svg';
import { ReactComponent as HalfStar } from 'images/new-icons/half-yellow-star.svg';
import { ReactComponent as GreyStar } from 'images/new-icons/grey-star.svg';
import { useTranslation } from 'react-i18next';
import useIsAuth from 'sdk/hooks/useIsAuth';
import useGetOrdersInTheCart from 'sdk/hooks/shop/useGetOrdersInTheCart';

type Props = {
  handleBack?: () => void;
  openBasket?: () => void;
};

const TopMenuForProduct: FC<Props> = ({ handleBack, openBasket }) => {
  const { id: idString } = useParams();
  const id = parseInt(idString || '', 10);
  const { data: reviews } = useGetProductReviewsByProductId(id);
  const {t}  = useTranslation() as any;
  const { data: isAuthData } = useIsAuth();
  const userId = isAuthData?.user?.id;
  const { data: cartItems, refetch: refetchCart } = useGetOrdersInTheCart(userId);

  useEffect(() => {
    refetchCart();
  }, [userId]);

  interface CartItem {
    count: number;
  }
  const itemCount = (cartItems as CartItem[] | undefined)?.reduce((total: number, item: CartItem) => total + (item.count || 0), 0) || 0;
  const displayCount: string | number = itemCount > 9 ? '9+' : itemCount;
  const renderStars = () => {
    const stars: JSX.Element[] = [];
    let remainingRank =
      reviews?.map((review: any) => review?.rank).reduce((a: number, b: number) => a + b, 0) /
      (reviews?.length || 1);

    for (let i = 0; i < 5; i++) {
      if (remainingRank >= 1) {
        stars.push(<Star key={i} />);
        remainingRank -= 1;
      } else if (remainingRank > 0) {
        stars.push(<HalfStar key={i} />);
        remainingRank = 0;
      } else {
        stars.push(<GreyStar key={i} />);
      }
    }

    return stars;
  };

  return (
    <div className={styles.container}>
      <div className={styles.top_menu_left}>
        <GoBackIcon onClick={handleBack} />
        <div className={styles.reviews}>
          <div className={styles.reviews_stars}>{renderStars()}</div>
          <span className={styles.dot}>•</span>
          
          <div className={styles.reviews_count}>{reviews?.length}</div>
          <div className={styles.reviews_text}>{t("Reviews")}</div>
        </div>
      </div>
      <div className={styles.cart_wrapper} onClick={openBasket}>
        <Bag />
        {itemCount > 0 && <div className={styles.counter}>{String(displayCount)}</div>}
      </div>
    </div>
  );
};

export default TopMenuForProduct;
